import React from 'react';
import {BrowserRouter, Routes, Route} from 'react-router-dom'
import ScrollToTop from './ScrollToTop';
import Header from './inc/Header';
import Footer from './inc/Footer';
import NotFound from './module/NotFound';
import Landing from "./module/Landing";
import Home from "./module/Home";
import About from "./module/About";
import Mission from "./module/Mission";
import Organization from "./module/Organization";
import Authority from "./module/Authority";
import Plan from "./module/Plan";
import OperatingResults from "./module/OperatingResults";
import OperatingResultsDetail from "./module/OperatingResultsDetail";
import MemberResults from "./module/MemberResults";
import MemberResultsDetail from "./module/MemberResultsDetail";
import Internal from "./module/Internal";
import Contact from "./module/Contact";
import Announcement from "./module/Announcement";
import AnnouncementDetail from "./module/AnnouncementDetail";
import Infographic from "./module/Infographic";
import InfographicDetail from "./module/InfographicDetail";
import News from "./module/News";
import NewsDetail from "./module/NewsDetail";
import Experts from "./module/Experts";
import ExpertsDetail from "./module/ExpertsDetail";
import ExpertsReport from "./module/ExpertsReport";
import Sitemap from "./module/Sitemap";

export default function Router() {

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="*" element={<><Header /><NotFound /><Footer /></>} />
        <Route path="/" exact={true} element={<><Landing /></>} />
        <Route path="/home" exact={true} element={<><Header /><Home /><Footer /></>} />
        <Route path="/sitemap" exact={true} element={<><Header /><Sitemap /><Footer /></>} />
        <Route path="/about" exact={true} element={<><Header /><About /><Footer /></>} />
        <Route path="/mission" exact={true} element={<><Header /><Mission /><Footer /></>} />
        <Route path="/organization" exact={true} element={<><Header /><Organization /><Footer /></>} />
        <Route path="/authority" exact={true} element={<><Header /><Authority /><Footer /></>} />
        <Route path="/plan" exact={true} element={<><Header /><Plan /><Footer /></>} />
        <Route path="/operating_results" exact={true} element={<><Header /><OperatingResults /><Footer /></>} />
        <Route path="/operating_results/detail/:slug" exact={true} element={<><Header /><OperatingResultsDetail /><Footer /></>} />
        <Route path="/member_results" exact={true} element={<><Header /><MemberResults /><Footer /></>} />
        <Route path="/member_results/detail/:slug" exact={true} element={<><Header /><MemberResultsDetail /><Footer /></>} />
        <Route path="/partners" exact={true} element={<><Header /><Internal /><Footer /></>} />
        <Route path="/contact" exact={true} element={<><Header /><Contact /><Footer /></>} />
        <Route path="/announcement" exact={true} element={<><Header /><Announcement /><Footer /></>} />
        <Route path="/announcement/detail/:slug" exact={true} element={<><Header /><AnnouncementDetail /><Footer /></>} />
        <Route path="/infographic" exact={true} element={<><Header /><Infographic /><Footer /></>} />
        <Route path="/infographic/detail/:slug" exact={true} element={<><Header /><InfographicDetail /><Footer /></>} />
        <Route path="/news/category/:slug" exact={true} element={<><Header /><News /><Footer /></>} />
        <Route path="/news/detail/:slug" exact={true} element={<><Header /><NewsDetail /><Footer /></>} />
        <Route path="/experts" exact={true} element={<><Header /><Experts /><Footer /></>} />
        <Route path="/experts/detail/:slug" exact={true} element={<><Header /><ExpertsDetail /><Footer /></>} />
        <Route path="/experts_report" exact={true} element={<><Header /><ExpertsReport /><Footer /></>} />

        {/* English */}
        <Route path="/en" exact={true} element={<><Landing lang="en" /></>} />
        <Route path="/en/home" exact={true} element={<><Header /><Home /><Footer lang="en" /></>} />
        <Route path="/en/sitemap" exact={true} element={<><Header lang="en" /><Sitemap lang="en" /><Footer /></>} />
        <Route path="/en/about" exact={true} element={<><Header lang="en" /><About lang="en" /><Footer lang="en" /></>} />
        <Route path="/en/mission" exact={true} element={<><Header lang="en" /><Mission lang="en" /><Footer lang="en" /></>} />
        <Route path="/en/organization" exact={true} element={<><Header lang="en" /><Organization lang="en" /><Footer lang="en" /></>} />
        <Route path="/en/authority" exact={true} element={<><Header lang="en" /><Authority lang="en" /><Footer lang="en" /></>} />
        <Route path="/en/plan" exact={true} element={<><Header lang="en" /><Plan lang="en" /><Footer lang="en" /></>} />
        <Route path="/en/operating_results" exact={true} element={<><Header lang="en" /><OperatingResults lang="en" /><Footer lang="en" /></>} />
        <Route path="/en/operating_results/detail/:slug" exact={true} element={<><Header lang="en" /><OperatingResultsDetail lang="en" /><Footer lang="en" /></>} />
        <Route path="/en/member_results" exact={true} element={<><Header lang="en" /><MemberResults lang="en" /><Footer lang="en" /></>} />
        <Route path="/en/member_results/detail/:slug" exact={true} element={<><Header lang="en" /><MemberResultsDetail lang="en" /><Footer lang="en" /></>} />
        <Route path="/en/partners" exact={true} element={<><Header lang="en" /><Internal lang="en" /><Footer lang="en" /></>} />
        <Route path="/en/contact" exact={true} element={<><Header lang="en" /><Contact lang="en" /><Footer lang="en" /></>} />
        <Route path="/en/announcement" exact={true} element={<><Header lang="en" /><Announcement lang="en" /><Footer lang="en" /></>} />
        <Route path="/announcement/detail/:slug" exact={true} element={<><Header lang="en" /><AnnouncementDetail lang="en" /><Footer /></>} />
        <Route path="/en/infographic" exact={true} element={<><Header lang="en" /><Infographic lang="en" /><Footer lang="en" /></>} />
        <Route path="/en/infographic/detail/:slug" exact={true} element={<><Header lang="en" /><InfographicDetail lang="en" /><Footer /></>} />
        <Route path="/en/news/category/:slug" exact={true} element={<><Header lang="en" /><News lang="en" /><Footer /></>} />
        <Route path="/en/news/detail/:slug" exact={true} element={<><Header lang="en" /><NewsDetail lang="en" /><Footer /></>} />
        <Route path="/en/experts" exact={true} element={<><Header lang="en" /><Experts lang="en" /><Footer lang="en" /></>} />
        <Route path="/en/experts/detail/:slug" exact={true} element={<><Header lang="en" /><ExpertsDetail lang="en" /><Footer /></>} />
        <Route path="/en/experts_report" exact={true} element={<><Header lang="en" /><ExpertsReport lang="en" /><Footer /></>} />

      </Routes>
    </BrowserRouter>
  ) 
} 